import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMap01 = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 6L9 2L2 6V22L9 18M16 6L22 2V18L16 22L9 18M9 18V2M16 22V6",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	})
});
export default SvgMap01;
